<!-- src/components/layout/FooterLinkLists.vue -->
<script setup lang="ts">
  import type { LayoutProps } from '@/types/ui/layouts';
  import { WindowService } from '@/services/window.service';

  const windowProps = WindowService.getMultiple([
    'plans_enabled',
    'plan',
    'support_host',
    'authentication',
  ]);
  defineProps<LayoutProps>();

</script>

<template>
  <div class="">
    <div class="mb-8 grid grid-cols-2 gap-8 py-6 pl-4 sm:pl-8 md:grid-cols-3 md:pl-16">
      <!-- Company links -->
      <div class="space-y-4">
        
        
      </div>

      <!-- Frontrunners.nl button -->
      <div class="space-y-4">
        <ul class="prose space-y-2 font-brand dark:prose-invert">
          
          <li>
                <li class="flex justify-center">
                  <a href="https://Frontrunners.com/nl" class="bg-[#C01E2E] text-white py-2 px-4 rounded hover:bg-red-700 font-bold no-underline">
                  Frontrunners
                  </a>
                </li>
            </li>
          
          
        </ul>
      </div>

      <!-- Legal links -->
      <div class="col-span-2 space-y-4 md:col-span-1">
        <ul class="prose space-y-2 font-brand dark:prose-invert">
          

          
        </ul>
      </div>
    </div>

    <!-- Border separator element -->
    <div class="my-2 border-t border-gray-200 dark:border-gray-700"></div>
  </div>
</template>
